import React, { useContext, useEffect } from 'react'
import { useLazyQuery, gql, NetworkStatus } from '@apollo/client'
import { Paper, Typography } from '@material-ui/core'
import ChartDonut from '../../../../components/charts/ChartDonut'
import ChartDonutSkeleton from '../../../../components/skeletons/ChartDonutSkeleton'
import { ChartColumnThemes } from '../../../../components/charts/types/ChartColumn'
import { formatNumber } from '../../../../utils/Helpers'
import { PharmaciesDetailsFiltersContext } from '../../../../context/PharmaciesDetailsFiltersContext'
import { STATUS_CANCELLED } from '../../../../types/Order'

const GET_DATA = gql`
  query CancelledReason($filters: JSON) {
    ordersAggs(
      size: 0,
      filters: $filters,
      query: {
        bool: {
          filter: [
            {
              terms: {
                status_translate_keyword: [
                  "${STATUS_CANCELLED}"
                ]
              }
            }
          ]
        }
      },
      aggs: {
        cancelationReason: {
          terms: {
            field: "cancellation_reason_translate.keyword",
            size: 10
          }
        }
      }
    ) {
      aggregations
    }
  }
`

interface Bucket {
  key: string
  doc_count: number
}
const CancelledReason = (): JSX.Element => {
  const { filters } = useContext(PharmaciesDetailsFiltersContext)
  const [getData, { loading, error, data, networkStatus }] = useLazyQuery(
    GET_DATA, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    getData({
      variables: { filters }
    })
  }, [filters])
  if (networkStatus === NetworkStatus.refetch) return <ChartDonutSkeleton />
  if (loading || !data) return <ChartDonutSkeleton />
  if (error) return <p>Error :(</p>
  if (!data.ordersAggs.aggregations) return <p>No data found</p>

  const { buckets } = data.ordersAggs.aggregations.cancelationReason
  const labels: Array<string> = []
  const series: Array<number> = []

  buckets.map((bucket: Bucket) => {
    labels.push(bucket.key)
    return series.push(bucket.doc_count)
  })

  const options = {
    chart: {
      id: 'cancelled-reason'
    },
    labels,
    yaxis: {
      show: false
    },
    fill: {
      opacity: 1
    },
    legend: {
      formatter: function (seriesName: string, opts: any) {
        let total = 0
        opts.w.globals.series.map((serie: any) => {
          total += serie
        })

        return [seriesName, ' - ', formatNumber((opts.w.globals.series[opts.seriesIndex] / total) * 100, 2), '%']
      },
      width: 220,
      height: 300
    },
    plotOptions: {
      polarArea: {
        rings: {
          strokeWidth: 0
        },
        spokes: {
          strokeWidth: 0
        }
      }
    }
  }

  if (!data) return <></>

  return <Paper elevation={2}>
    <Typography paragraph style={{ paddingLeft: '20px', paddingTop: '20px' }}>Motivo de cancelamento</Typography>
    <ChartDonut options={options} series={series} theme={ChartColumnThemes.rainbow} type="donut" />
  </Paper>
}

export default CancelledReason
